import { apiClient } from '@/services/api';
import type { ApiResponse, PublicUser } from '@/types/auth';

class UserAccountService {
  getProfile() {
    return apiClient.get<ApiResponse<{ user: PublicUser }>>('/users/profile');
  }

  updateProfile(data: Partial<{
    firstName: string;
    lastName: string;
    email: string;
    state: string;
    gender: string;
    nin: string;
    bvn: string;
    dateOfBirth: string;
  }>) {
    return apiClient.patch<ApiResponse<{ user: PublicUser }>>('/users/profile', data);
  }

  changePassword(currentPassword: string, newPassword: string) {
    return apiClient.post<ApiResponse>('/users/security/password', {
      currentPassword,
      newPassword,
    });
  }

  setTransactionPin(pin: string, confirmPin: string) {
    return apiClient.post<ApiResponse<{ user: PublicUser }>>('/users/security/transaction-pin', {
      pin,
      confirmPin,
    });
  }

  changeTransactionPin(currentPin: string, newPin: string, confirmPin: string) {
    return apiClient.patch<ApiResponse<{ user: PublicUser }>>('/users/security/transaction-pin', {
      currentPin,
      newPin,
      confirmPin,
    });
  }
}

export const userAccountService = new UserAccountService();
